import EntityMapTabState from 'registry/entity-map/tab/EntityMapTabState';
import EntityMapTabView from 'registry/entity-map/tab/EntityMapTabView';

const EntityMapTab = {
  tabState: EntityMapTabState,
  tabView: EntityMapTabView,
};

export default EntityMapTab;
